<template>
  <div class="business-type-slide slide-base"  data-step-name="Typ">
    <div class="slide-content">
      <div class="slide-inner">
        <div class="main-section">
          <!-- Header Section -->
          <div class="header-section">
            <h1 class="slide-title" v-html="title"></h1>
            <p class="slide-description">Wählen Sie die Art der Gewerbeimmobilie</p>
          </div>

          <!-- Options Grid -->
          <div class="options-grid">
            <button
              class="option-card"
              @click="next('Büro- oder Praxis')"
            >
              <div class="icon-container">
                <BueroOderLagergebaudeIcon/>
              </div>
              <div class="option-content">
                <span class="option-title">Büro- oder Praxis</span>
                <span class="option-description">Bürofläche oder Praxisräume</span>
              </div>
              <span class="hover-arrow">→</span>
            </button>

            <button
              class="option-card"
              @click="next('Wohn- und Geschäftshaus')"
            >
              <div class="icon-container">
                <WohnUndGeschaftsgebaudeIcon/>
              </div>
              <div class="option-content">
                <span class="option-title">Wohn- und Geschäftshaus</span>
                <span class="option-description">Kombinierte Wohn- und Gewerbeflächen</span>
              </div>
              <span class="hover-arrow">→</span>
            </button>

            <button
              class="option-card"
              @click="next('Industriegebäude')"
            >
              <div class="icon-container">
                <IndustriegebaudeIcon/>
              </div>
              <div class="option-content">
                <span class="option-title">Industriegebäude</span>
                <span class="option-description">Produktions- oder Lagerflächen</span>
              </div>
              <span class="hover-arrow">→</span>
            </button>

            <button
              class="option-card"
              @click="next('Handel / Retail')"
            >
              <div class="icon-container">
                <WohnUndLadengeschaftIcon/>
              </div>
              <div class="option-content">
                <span class="option-title">Handel / Retail</span>
                <span class="option-description">Einzelhandel oder Geschäftsflächen</span>
              </div>
              <span class="hover-arrow">→</span>
            </button>

            <button
              class="option-card"
              @click="next('Sonstiges')"
            >
              <div class="icon-container">
                <SonstigesIcon/>
              </div>
              <div class="option-content">
                <span class="option-title">Sonstiges</span>
                <span class="option-description">Andere gewerbliche Nutzungsart</span>
              </div>
              <span class="hover-arrow">→</span>
            </button>
          </div>
        </div>

        <div class="footer-section">
          <div class="navigation-buttons">
            <button class="nav-button prev-button" @click="prev">
              <i class="button-icon fas fa-arrow-left"></i>
            </button>
            <button class="nav-button next-button" @click="next">
              <i class="button-icon fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BueroOderLagergebaudeIcon from '@/assets/icons/buero-oder-lagergebauede.svg'
import WohnUndGeschaftsgebaudeIcon from '@/assets/icons/wohn-und-geschaeftsgebaeude.svg'
import IndustriegebaudeIcon from '@/assets/icons/industrie-oder-geschaeftsgebaeude.svg'
import WohnUndLadengeschaftIcon from '@/assets/icons/wohn-und-ladengeschaeft.svg'
import SonstigesIcon from '@/assets/icons/sonstiges.svg'
import slideMixin from '@/mixins/slideMixin'

export default {
  name: 'BusinessTypeSlide',
  mixins: [slideMixin],
  computed: {
    isTransitioning () {
      return this.$store.state.isTransitioning
    }
  },
  components: {
    BueroOderLagergebaudeIcon,
    WohnUndGeschaftsgebaudeIcon,
    IndustriegebaudeIcon,
    WohnUndLadengeschaftIcon,
    SonstigesIcon
  },
  props: {
    title: String
  },
  methods: {
    next (choice) {
      this.$store.commit('updateCollectedData', { businessType: choice })
      this.$store.commit('nextSlide')
    },
    prev () {
      this.$store.commit('prevSlide')
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/_layout.scss';

.business-type-slide {
  .header-section {
    margin-bottom: 2rem;
    padding-top: 2rem; // Abstand für pagination

    .slide-title {
      font-size: clamp(1.5rem, 4vw, 2rem);
      color: var(--primary-color);
      font-weight: 600;
      margin-bottom: 0.5rem;
      line-height: 1.3;
    }

    .slide-description {
      font-size: 1.1rem;
      color: #666;
      margin: 0;
    }
  }

  .options-grid {
    display: grid;
    gap: 1rem;
    margin-bottom: 2rem;
    padding-bottom: calc(1rem + 76px); // Extra Padding für Footer
  }

  .option-card {
    position: relative;
    display: grid;
    grid-template-columns: 80px 1fr auto;
    align-items: center;
    gap: 1.25rem;
    padding: 1.5rem;
    background: #f8fafc;
    border: 2px solid transparent;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: left;
    width: 100%;
    min-height: 44px;

    &:hover {
      transform: translateY(-2px);
      border-color: var(--secondary-color);
      background: white;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

      .hover-arrow {
        opacity: 1;
        transform: translateX(0);
      }

      .icon-container {
        background: rgba(23, 181, 160, 0.1);

        svg {
          color: var(--secondary-color);
        }
      }
    }

    .icon-container {
      width: 64px;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f1f5f9;
      border-radius: 16px;
      transition: all 0.3s ease;
      padding: 1rem;

      svg {
        width: 100%;
        height: 100%;
        color: #64748b;
        transition: all 0.3s ease;
      }
    }

    .option-content {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      flex: 1;
      min-width: 0;
    }

    .option-title {
      font-size: 1.1rem;
      color: var(--primary-color);
      font-weight: 500;
    }

    .option-description {
      font-size: 0.9rem;
      color: #666;
      line-height: 1.4;
    }

    .hover-arrow {
      font-size: 1.25rem;
      color: var(--secondary-color);
      opacity: 0;
      transform: translateX(-10px);
      transition: all 0.3s ease;
      padding-left: 0.5rem;
    }
  }

  @media (max-width: 768px) {
    .main-section {
      padding: 1rem;
      padding-bottom: calc(1rem + 76px); // Extra Padding für den Footer

      .header-section {
        margin-bottom: 1.5rem;

        .slide-title {
          font-size: 1.5rem;
        }

        .slide-description {
          font-size: 1rem;
        }
      }

      .option-card {
        grid-template-columns: 60px 1fr auto;
        padding: 1.25rem;
        gap: 1rem;

        .icon-container {
          width: 48px;
          height: 48px;
        }

        .option-title {
          font-size: 1rem;
        }

        .option-description {
          font-size: 0.85rem;
        }
      }
    }
  }
}
</style>
